/* eslint-disable */
export default {
  recentActivities: 'Actividades recientes',
  text: 'Mensaje',
  fax: 'Fax',
  voicemail: 'Buzón de voz',
  call: 'Llamar',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
